import { IFormField } from '@topshots/core-models';
import styles from './field-list-item.module.css';
import { ArrowUpIcon, PencilIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { ArrowDownIcon } from '@heroicons/react/24/outline';

export const FieldListItem = ({
  field,
  onEdit,
  onRemove,
  onDown,
  onUp,
  isFirst,
  isLast,
}: {
  field: IFormField;
  isFirst: boolean;
  isLast: boolean;
  onEdit: (id: string) => void;
  onUp: (id: string) => void;
  onDown: (id: string) => void;
  onRemove: (id: string) => void;
}) => {
  return (
    <div key={field.id} className={styles.fieldSummary}>
      <div className={styles.fieldInfo}>
        <span className={styles.fieldLabel}>{field.label}</span>
        <span className={styles.fieldType}>({field.type})</span>
        {field.required && (
          <span className={styles.requiredBadge}>Required</span>
        )}
      </div>
      <div className={styles.fieldActions}>
        {!isFirst && (
          <ArrowUpIcon
            className={styles.moveUp}
            onClick={() => {
              onUp(field.id);
            }}
          />
        )}
        {!isLast && (
          <ArrowDownIcon
            className={styles.moveDown}
            onClick={() => {
              onDown(field.id);
            }}
          />
        )}
        <PencilIcon
          className={styles.editField}
          onClick={() => {
            onEdit(field.id);
          }}
        />
        <XMarkIcon
          className={styles.removeField}
          onClick={() => {
            onRemove(field.id);
          }}
        />
      </div>
    </div>
  );
};
